import axios from 'axios';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { show_alerta } from '../../funciones.js';

import CONFIG from '../../config';

const URL = `${CONFIG.API_URL}/buscaRolesUsuario.php`;
const URL_USUARIO = `${CONFIG.API_URL}/operarTablaUsuario.php`;
const URL_ROLES = `${CONFIG.API_URL}/operarRoles.php`;

function UsuarioRoles({ id_usuario, rol }) {
    const [rolesUsuario, setRolesUsuario] = useState([]);
    const loggeduserRolId = parseInt(localStorage.getItem('loggeduserRolId') || rol || 99, 10);

    useEffect(() => {
        buscarRoles();
    }, [id_usuario]);

    const buscarRoles = () => {
        const data = {
            'id_usuario': id_usuario,
            'modo': 'buscarRolesUsuario'
        };
        axios.post(URL, data)
            .then(res => {
                if (!res.data.error) {
                    setRolesUsuario(res.data);
                } else {
                    setRolesUsuario([]);
                }
            })
            .catch(err => {
                console.log(err);
            });
    };

    const eliminaRol = async (id_usuario, id_rol, id_nivel, nombreRol) => {
        // Verificar si el usuario está asociado a cursos con este rol
        let asociado = false;
        let cantidad = 0;
        try {
            const checkRes = await axios.post(URL_ROLES, {
                modo: 'verificarAsociacionRol',
                id_usuario: id_usuario,
                id_rol: id_rol
            });
            if (checkRes.data && checkRes.data.asociado) {
                asociado = true;
                cantidad = checkRes.data.cantidad;
            }
        } catch (err) {
            console.log(err);
        }

        const MySwal = withReactContent(Swal);

        let htmlContent = `
            <div class="text-start" style="font-size: 0.95rem;">
                <p class="text-secondary mb-2">
                    <i class="fa-solid fa-lock text-warning me-1"></i>
                    <strong>Advertencia:</strong> Al quitar el rol <strong>${nombreRol || ''}</strong>, el usuario ya no podrá acceder a ese perfil.
                </p>
        `;

        if (asociado) {
            htmlContent += `
                <div class="alert alert-warning border border-warning-subtle text-dark p-2 rounded-3 small mt-2 mb-0" style="background-color: #fff3cd;">
                    <i class="fa-solid fa-triangle-exclamation text-warning me-1"></i>
                    <strong>Atención:</strong> Este usuario se encuentra actualmente asignado a <strong>${cantidad} curso(s)</strong> en el sistema.
                    <br/><br/>
                    Esta acción quitará el rol del usuario, pero <strong>NO lo eliminará automáticamente de los cursos</strong>. Si fue un error o desea desvincularlo totalmente, recuerde eliminarlo también de los cursos correspondientes.
                </div>
            `;
        }

        htmlContent += `</div>`;

        MySwal.fire({
            title: '¿Seguro de quitar este rol?',
            html: htmlContent,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, quitar rol',
            cancelButtonText: 'Cancelar',
            customClass: {
                confirmButton: 'btn btn-danger mx-2 shadow-sm',
                cancelButton: 'btn btn-outline-secondary mx-2',
                popup: 'rounded-4 shadow'
            },
            buttonsStyling: false
        }).then(resConfirm => {
            if (resConfirm.isConfirmed) {
                enviarSolicitud('DELETE', {
                    id_usuario: id_usuario,
                    id_rol: id_rol,
                    id_nivel: id_nivel,
                    rol_solicitante: loggeduserRolId
                });
            }
        });
    };

    const enviarSolicitud = async (metodo, parametros) => {
        await axios({ method: metodo, url: URL_USUARIO, data: parametros })
            .then(res => {
                var tipo = res.data[0];
                var msj = res.data[1];
                show_alerta(msj, tipo);
                buscarRoles();
            })
            .catch(err => {
                show_alerta('Error en la solicitud ', 'error');
                console.log(err);
            });
    };

    return (
        <div>
            {!!rolesUsuario && rolesUsuario.map((r, idx) => {
                // Permiso para mostrar tachito de eliminar:
                // Solo si el usuario logueado tiene rol de gestión (<= 3)
                // y el rol a eliminar (r.id) es igual o inferior en nivel jerárquico (r.id >= loggeduserRolId)
                // Es decir, rol 3 (Director) NO podrá quitar roles 1 (SuperAdmin) ni 2 (Admin).
                const puedeEliminar = (loggeduserRolId <= 3) && (r.id >= loggeduserRolId);

                return (
                    <div key={r.id + '_' + (r.id_nivel || idx)} className='row align-items-center mb-1'>
                        <div className='col-8 text-truncate'>
                            <small><i className={r.icono}></i> {r.nombre}</small>
                        </div>
                        <div className='col-3 text-end'>
                            {puedeEliminar && (
                                <small>
                                    <button
                                        className='btn btn-sm btn-outline-danger border-0 py-0 px-1'
                                        onClick={() => eliminaRol(id_usuario, r.id, r.id_nivel, r.nombre)}
                                        title={`Quitar rol ${r.nombre}`}
                                    >
                                        <i className='fa fa-solid fa-trash'></i>
                                    </button>
                                </small>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default UsuarioRoles;